import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const Carousel = {
  slide: css`
    display: flex;
    justify-content: center;
    border: none;
    width: 100%;
    height: 600px;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: var(--slide-image);
    @media screen and (max-width: ${dimensions.tablet}) {
      height: auto;
      background-image: none;
      padding: 0;
    }
  `,
  slideCol: css`
    width: 100%;
    height: 100%;
  `,
  slideSection: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  `,

  slideImage: css`
    width: 40%;
    height: 200px;
    display: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: var(--slide-image);
    padding: 3rem;

    @media screen and (max-width: ${dimensions.tablet}) {
      display: block;
      width: 100%;
      border-radius: 8px 8px 0 0;
    }
  `,

  slideContent: (theme: Theme) => css`
    width: auto;
    height: 100%;
    padding: 3rem 2rem;
    @media screen and (max-width: ${dimensions.tablet}) {
      width: 100%;
      padding: 3rem;
      background-color: ${theme.system.backgroundMuted};
      border-radius: 0 0 8px 8px;
    }
  `,
  callToAction: css`
    width: 100%;
  `,
};
